module.exports = __webpack_public_path__ + "img/gear-fill.74c42c83.svg";